export var PdpTemplate;
(function (PdpTemplate) {
  PdpTemplate["SingleUnitVr"] = "SINGLE_UNIT_VR";
  PdpTemplate["MultiUnitVr"] = "MULTI_UNIT_VR";
  PdpTemplate["ConventionalLodging"] = "CONVENTIONAL_LODGING";
})(PdpTemplate || (PdpTemplate = {}));
const PDP_BASE_TEMPLATES = Object.values(PdpTemplate);
export const isBasePdpTemplate = value => PDP_BASE_TEMPLATES.includes(value);
export const isPdpTemplate = value => PDP_BASE_TEMPLATES.some(baseTemplate => baseTemplate.concat('_LARGE') === value || baseTemplate.concat('_SMALL') === value);
export var SrpTemplate;
(function (SrpTemplate) {
  SrpTemplate["ListView"] = "LIST_VIEW";
  SrpTemplate["SplitView"] = "SPLIT_VIEW";
  SrpTemplate["listViewPillsExp"] = "LIST_VIEW_PILLS_EXP";
})(SrpTemplate || (SrpTemplate = {}));
const SRP_TEMPLATES = Object.values(SrpTemplate);
export const isSrpTemplate = value => SRP_TEMPLATES.includes(value);